import { flowQuery, flowsListQuery } from '../../../../api-v2/queries/flows-list-query';
import userListQuery from '../../../../api-v2/queries/user-list-query';

export const flowsPageLoader = (queryClient) => async (opts) => {
  const url = new URL(opts.request.url);
  const archived = url.searchParams.get('archived')
    ? url.searchParams.get('archived') === 'true'
    : false;
  await queryClient.ensureQueryData(flowsListQuery());
  await queryClient.ensureQueryData(userListQuery());

  return { archived };
};

export const editFlowPageLoader = (queryClient) => async (opts) => {
  const { flowId } = opts.params;
  await queryClient.ensureQueryData(flowQuery({ flowId }));

  return { flowId };
};
